
  /**
   * @license
   * author: epignosis front-end team
   * @epignosis_llc/gnosis.js v6.0.0
   * Released under the MIT license.
   */

var isFunction = function (value) {
  return typeof value === 'function';
};

export { isFunction };
//# sourceMappingURL=index.js.map
